import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

const INSURER_ADMIN_CX_GROUPS = [
  UserGroup.INSURER_ADMINISTRATOR,
  UserGroup.INSURER_CUSTOMER_SUPPORT,
];

/**
 * Seg Adm ou Seg CX — espelha o `isInsurerAdminOrCxUser` do backend.
 *
 * São os únicos perfis que podem trocar a corretora vinculada de um usuário;
 * o corretor master edita os demais dados, mas não o vínculo.
 */
export function useIsInsurerAdminOrCx() {
  const { checkUserGroups } = useAuth();
  const [isInsurerAdminOrCx, setIsInsurerAdminOrCx] = useState<boolean | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups(INSURER_ADMIN_CX_GROUPS);
      setIsInsurerAdminOrCx(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { isInsurerAdminOrCx, isLoading };
}
